/**
 * loadSwitcher.js — adds VarahiID's 9-dot app switcher script (2026-09-24).
 *
 * Happen, Converse and GetScreened include it statically in index.html:
 *   <script src="/id/switcher.js" defer></script>
 * and render <div data-varahi-switcher/> where the button belongs. MHI loads the
 * same script, but only when VITE_AUTH_MODE=varahiid: with sign-in off (the
 * offline / Pi demo) there is no VarahiID to reach, and the page must render
 * exactly as it did before. The script watches for placeholders added later
 * (MutationObserver), so injecting it after the placeholder mounts is enough.
 */
import { AUTH_ENABLED, SWITCHER_SRC } from '../../auth/config.js';

const SCRIPT_ID = 'varahi-switcher-js';

export default function loadSwitcher() {
  if (!AUTH_ENABLED || typeof document === 'undefined') return;
  if (document.getElementById(SCRIPT_ID) || window.VarahiSwitcher) return;
  const s = document.createElement('script');
  s.id = SCRIPT_ID;
  s.src = SWITCHER_SRC;
  s.defer = true;
  // VarahiID down: the switcher is decoration here, the rest of the menu still works.
  s.onerror = () => { s.remove(); };
  document.head.appendChild(s);
}
